export class User {
  // id?: string;
  // email: string;
  // first_name?: string;
  // last_name?: string;
  // // profile?: Profile;
  // genre?: string;
  // code?: number;
  // password?: string;

  id: string;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  mobile_number: string;
  language_code: string;
  country_code: string;
  cognito_identity_id: string;
  engaged_at: string;
  password?: string;
  code?: number;
  genre?: string;
  picture_url?: string;


  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }

}

// export interface Profile {
//   country: string;
//   language: string;
//   mobile_number?: string;
//   picture_url?: string;
// }

// export interface SessionUser {
//   email: string;
//   access_token: string;
//   refresh_token: string;
//   method: string;
//   guest: boolean;
// }
